import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableAddOns = loadable(() => import('./AddOns'), {
  fallback: <LoadingScreen />,
});

export default LoadableAddOns;
